import type { ReactNode } from "react";
import { cn } from "./cn";

/**
 * Record details separated by horizontal rules. Stacks on narrow screens.
 */
export function InfoTable({ rows, className }: { rows: { label: ReactNode; value: ReactNode }[]; className?: string }) {
  return (
    <dl className={cn("border-y border-line text-sm", className)}>
      {rows.map((r, i) => (
        <div key={i} className="grid border-b border-line last:border-b-0 sm:grid-cols-[11rem_1fr]">
          <dt className="py-2 font-bold text-ink-2 sm:py-3">{r.label}</dt>
          <dd className="min-w-0 pb-3 break-words sm:py-3">{r.value}</dd>
        </div>
      ))}
    </dl>
  );
}
